import {
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    SIGNOUT_SUCCESS,
    SIGNUP_SUCCESS,
    SIGNUP_ERROR,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_ERROR,
    OTP_RESPONSE_WAITING,
    OTP_RESPONSE_RECEIVED,
    SET_LINK_METHOD,
    EXTERNAL_LOGIN
} from './../constants/constants';

const initialState = {
    loggedIn: null,
    authError: null,
    emailSent: null,
    provider: '',
    OTPResponseReceived: false,
    linkMethod: '',
    encryptedToken:'',
}

const authReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case LOGIN_ERROR:
            return {
                ...state,
                authError: 'Login failed'
            }
        case SET_LINK_METHOD:
            return {
                ...state,
                linkMethod: ('linkMethod' in action.payload) ? action.payload.linkMethod : state.linkMethod,
            }
        case LOGIN_SUCCESS:
            return {
                ...state,
                provider: action.payload,
                authError: null,
                loggedIn: true,
            }

        case SIGNUP_SUCCESS:
            return {
                ...state,
                authError: null,
                loggedIn: true,
            }

        case SIGNUP_ERROR:
            return {
                ...state
            }

        case SIGNOUT_SUCCESS:
            return {
                ...initialState,
            }

        case PASSWORD_RESET_SUCCESS:
            return {
                ...state,
                emailSent: true
            }

        case PASSWORD_RESET_ERROR:
            return {
                ...state,
                emailSent: false
            }
        case OTP_RESPONSE_WAITING:
            return {
                ...state,
                OTPResponseReceived: false,
            }
        case OTP_RESPONSE_RECEIVED:
            return {
                ...state,
                OTPResponseReceived: true,
            }
        case EXTERNAL_LOGIN:
            return {
                ...state,
                encryptedToken: ('encryptedToken' in action.payload) ? action.payload.encryptedToken : state.encryptedToken,
            }
        default:
            return state
    }
};

export default authReducer;